import { render, staticRenderFns } from "./ComfyOnboarding.vue?vue&type=template&id=081a6567&scoped=true"
import script from "./ComfyOnboarding.vue?vue&type=script&lang=js"
export * from "./ComfyOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a6567",
  null
  
)

export default component.exports